import { call, put, takeEvery, select } from 'redux-saga/effects';
import { getType } from 'typesafe-actions';

import { RootState } from '../reducers/rootReducer';
import { getCompletedEPOrders, setOrders } from '../actions/orders.actions';
import { setLoading } from '../actions/loading.actions';
import { mapGetCompletedEPToursResponseToSetCompletedEPToursPayload } from './getCompletedEPTours.mappers';

import { BFF_V1, BFF_PICK_TOURS, BFF_HISTORY, SAGA_GET_COMPLETED_EP_ORDERS , PICKING_APIGEE_BASE_PATH } from '../../constants';

import { GetCompletedEPOrdersPayload } from '../actions/orders.types';
import { OrdersState } from '../reducers/types';
import { ConfigAuthValues } from '../../types';

import { callAPI } from '../../utils';

import { handleApiErrors, catchApiErrors } from './utils';


const callGetCompletedEPOrders = (orderCallData: GetCompletedEPOrdersPayload, configAuthValues: ConfigAuthValues) => {
  return callAPI({
    method: 'GET',
    url: `${configAuthValues.APIGEE_BASE_URL}${PICKING_APIGEE_BASE_PATH}${BFF_V1}${BFF_PICK_TOURS}${BFF_HISTORY}?storeId=${orderCallData.fulfillmentStoreID}&page=${orderCallData.pageNumber}&size=10`,
  });
};

export function* runGetCompletedEPOrdersSaga(action: { type: string; payload: GetCompletedEPOrdersPayload }) {
  yield put(setLoading({ sagaName: SAGA_GET_COMPLETED_EP_ORDERS, isLoading: true }));

  const configAuthValues = yield select((state: RootState) => state.config.authValues);
  const ordersState: OrdersState = yield select((state: RootState) => state.orders);

  try {
    const result = yield call(
      callGetCompletedEPOrders,
      {
        fulfillmentStoreID: action.payload.fulfillmentStoreID,
        pageNumber: action.payload.pageNumber,
      },
      configAuthValues
    );

    const completedEPTours = mapGetCompletedEPToursResponseToSetCompletedEPToursPayload(result);

    yield put(
      setOrders({
        ordersByType: ordersState.ordersByType,
        completedEPTours,
      })
    );

    yield handleApiErrors(result.data.errors);
  } catch (error) {
    try {
      const orderCallData = {
        fulfillmentStoreID: action.payload.fulfillmentStoreID,
        pageNumber: action.payload.pageNumber,
      };
      const url = `${PICKING_APIGEE_BASE_PATH}${BFF_V1}${BFF_PICK_TOURS}${BFF_HISTORY}?storeId=${
        orderCallData.fulfillmentStoreID
      }&page=${orderCallData.pageNumber}&size=10`;
      const method = 'GET';
      const data = {};
      const config = configAuthValues;
      yield catchApiErrors(error, { url, method, data, config, saga: SAGA_GET_COMPLETED_EP_ORDERS });
    } catch (_error) {
      yield catchApiErrors(error);
    }
  }

  yield put(setLoading({ sagaName: SAGA_GET_COMPLETED_EP_ORDERS, isLoading: false }));
}

export default function* watchGetCompletedEPOrders() {
  yield takeEvery(getType(getCompletedEPOrders), runGetCompletedEPOrdersSaga);
}
